import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getSingleTransactionHeaderInfo = (id: string) => {
  return axiosPrivate.get(`/dashboard/v1/transaction/${id}`);
};

export const getSingleTransactionDetails = (id: string) => {
  return axiosPrivate.get(`/dashboard/v1/transaction/${id}/detail`);
};